import React from 'react';

import { NoticeProps } from '../../types';

import SaleTagIcon from './assets/sale_tag_icon.svg';

interface Props extends NoticeProps {
  role: 'sale';
}

export default (props: Props) => {
  return (
    <div className="align-items-center d-flex gap-s justify-content-center">
      {
        props.role === 'sale' && (
          <div className="flex-none">
            <img
              alt="Sale tag icon"
              height="20px"
              src={SaleTagIcon}
              width="20px"
            />
          </div>
        )
      }

      <div
        dangerouslySetInnerHTML={{ __html: props.message }}
      />
    </div>
  )
};
